/* global axios */
import ApiClient from './ApiClient';

class ScimSettingsAPI extends ApiClient {
  constructor() {
    super('scim_settings', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create() {
    return axios.post(this.url);
  }

  rotate() {
    return axios.put(this.url, { action_type: 'rotate' });
  }

  revoke() {
    return axios.put(this.url, { action_type: 'revoke' });
  }

  delete() {
    return axios.delete(this.url);
  }
}

export default new ScimSettingsAPI();
